import { useMutation } from "@tanstack/react-query";
import * as API from "common/api";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * @typedef {Object} OccurrenceEventHookProps
 * @property {string} accessToken
 * @property {string} categoryId
 * @property {string} liffId
 *
 * @param {OccurrenceEventHookProps} props
 */
export default function useOccurrenceEvent({ accessToken, occurrenceId }) {
	const navigate = useNavigate();
	const { search } = useLocation();
	const searchParams = new URLSearchParams(search);

	const getPersonalInfo = useMutation(
		["category_details", "before_get_payment_key"],
		() => API.CLIENT_GET_PERSONAL_INFO(accessToken),
	);

	const getPurchaseOccurrence = useMutation(
		["category_details", "purchase_category"],
		(occurrenceId) =>
			API.CLIENT_GET_PURCHASE_OCCURRENCES({ accessToken, occurrenceId }),
	);

	const paymentMutation = useMutation(
		["category_details", "get_payment_key", occurrenceId],
		async () => {
			const { data: session } = await getPersonalInfo.mutateAsync();
			const {
				data: { purchased, paymentKey },
			} = await getPurchaseOccurrence.mutateAsync(occurrenceId);

			if (!session) {
				return;
			}

			const onNavigate = () => {
				navigate(`${occurrenceId}/?isProgram=${searchParams.get("isProgram")}`);
			};

			if (!purchased) {
				window.pop.pay(paymentKey, {
					onSuccess: () => {
						onNavigate();
					},
				});
			} else {
				onNavigate();
			}
		},
	);

	const handlePayment = (...variables) => {
		if (paymentMutation.isLoading) {
			return;
		}

		paymentMutation.mutate(...variables);
	};

	return {
		paymentMutation,
		handlePayment,
		loading: paymentMutation.isLoading,
	};
}
